import { Sort } from "@angular/material/sort";
import { Customer } from "@core/models/customer.model";
import { Order } from "@core/models/order.model";
import { OrderOwner } from "@order/models/order-owner";
import { NavigationState } from "@shared/models/navigation-state";

export class OrderNavigationState extends NavigationState {
	override readonly className = "OrderNavigationState";

	customer?: Customer;
	isUpdated?: boolean;
	needsCalc?: boolean;
	order?: Order;
	orderOwner?: OrderOwner;

	orderLinesTableSort: Sort | undefined;
}
